import React, { useEffect, lazy, createElement, Component } from 'react';
import { Check, CheckCircle, Truck, ThumbsUp, BadgeCheck, MessageCircle, ChevronRight, Droplets, Activity, Leaf } from 'lucide-react';
// Datos de los comentarios estilo Facebook
const commentsData = [{
  id: 1,
  name: 'Alicia Prado',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/bYki87VQaRVxYf4jX3bKTH/13.jpg',
  text: '¿Alguien lo ha probado para la barriga? Yo ya no sé qué hacer 😩',
  likes: 5,
  time: 'hace 12 min',
  replies: [{
    id: 11,
    name: 'Carmen Soler',
    verified: false,
    avatar: 'https://cdn.magicpatterns.com/uploads/h1eXJjEnyQgh7knHHMA6wY/Captura_de_pantalla_2026-04-23_a_las_10.35.12.png',
    text: 'Yo Alicia, 4 semanas y los pantalones que tenía guardados me entran otra vez. No me lo creo todavía.',
    likes: 14,
    time: 'hace 8 min'
  }]
}, {
  id: 4,
  name: 'Montse Vidal',
  verified: false,
  text: 'Yo igual que tú Alicia, llevaba años echándome la culpa de no adelgazar. Y resulta que era tema hormonal de la edad. Ojalá lo hubiera sabido antes 😪',
  likes: 11,
  time: 'hace 15 min'
}, {
  id: 2,
  name: 'Rosa María Delgado',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/7ZPYeMbzHkXYhTJReeshy4/20.jpg',
  text: "Mi marido me dijo ayer 'qué te has hecho en la cara'. No sabía si reírme o llorar jajaj",
  likes: 9,
  time: 'hace 20 min'
}, {
  id: 5,
  name: 'Pilar Aguirre',
  verified: false,
  text: 'Lo que más me gustó es que no es una pastilla más. Es líquido, una cucharadita en el café por la mañana y listo. Yo de las cápsulas ya estaba harta.',
  likes: 7,
  time: 'hace 25 min'
}, {
  id: 6,
  name: 'Maite Fernández',
  verified: false,
  text: 'No me ha bajado la báscula tanto como esperaba pero la sensación de ligereza por las tardes es otra cosa. Ya no me siento hinchada a las 6 de la tarde.',
  likes: 6,
  time: 'hace 33 min'
}, {
  id: 7,
  name: 'Begoña Ortiz',
  verified: false,
  text: 'Yo lo pedí solo porque tenía 60 días para devolverlo si no funcionaba, no perdía nada. Pues mira, no lo voy a devolver jeje',
  likes: 13,
  time: 'hace 41 min'
}, {
  id: 3,
  name: 'Inma Torres',
  verified: false,
  avatar: 'https://cdn.magicpatterns.com/uploads/fc4g3HBghwwcrpVPxb7T15/3_1.jpg',
  text: 'Llevo 3 semanas. La báscula ha bajado 4 kilos pero lo que más noto es la barriga. Ya no la escondo.',
  likes: 18,
  time: 'hace 48 min',
  replies: [{
    id: 31,
    name: 'Loli Sánchez',
    verified: false,
    text: 'Inma a mí me pasó igual, 3 semanas y la barriga es lo primero que noté. Mi hija me preguntó si había hecho dieta y le dije que no, que justo lo contrario 😂',
    likes: 8,
    time: 'hace 1 h'
  }]
}, {
  id: 8,
  name: 'Conchi Romero',
  verified: false,
  text: 'Yo soy de las escépticas, había probado de TODO. Esto es lo único que me ha hecho algo de verdad. Voy por el segundo bote.',
  likes: 15,
  time: 'hace 1 h'
}];
// Utilidad para obtener iniciales
const getInitials = (name: string) => {
  return name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
};
// Componente de Comentario Individual
const Comment = ({
  comment,
  isReply = false
}: {
  comment: any;
  isReply?: boolean;
}) => <div className={`flex gap-2 ${isReply ? 'mt-3' : 'mt-4'}`} data-id="element-0">
    <div className="flex-shrink-0" data-id="element-1">
      {comment.avatar ? <img src={comment.avatar} alt={comment.name} loading="lazy" decoding="async" className="w-10 h-10 rounded-full object-cover" data-id="element-2" /> : <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-bold text-sm" data-id="element-3">
          {getInitials(comment.name)}
        </div>}
    </div>
    <div className="flex-1" data-id="element-4">
      <div className="bg-[#f0f2f5] rounded-2xl px-3 py-2 inline-block max-w-full" data-id="element-5">
        <div className="flex items-center flex-wrap gap-1 mb-1" data-id="element-6">
          <span className="font-bold text-[15px] text-[#050505] hover:underline cursor-pointer" data-id="element-7">
            {comment.name}
          </span>
          {comment.verified && <span className="flex items-center text-[#1877F2] text-[13px] font-medium ml-1" data-id="element-8">
              <BadgeCheck size={14} className="mr-1" fill="currentColor" stroke="white" data-id="element-9" />
              Compra verificada
            </span>}
        </div>
        <p className="text-[15px] text-[#050505] m-0 leading-snug" data-id="element-10">
          {comment.text}
        </p>
        {comment.image && <img src={comment.image} alt="Imagen adjunta" loading="lazy" decoding="async" className="mt-2 max-w-[240px] w-full h-auto mx-auto block" data-id="element-11" />}
      </div>
      <div className="flex items-center gap-4 text-[13px] text-[#65676B] font-bold mt-1 ml-3" data-id="element-12">
        <button className="hover:underline" data-id="element-13">Me gusta</button>
        <button className="hover:underline" data-id="element-14">Responder</button>
        <span className="font-normal" data-id="element-15">{comment.time}</span>
        {comment.likes > 0 && <div className="flex items-center gap-1 bg-white shadow-sm border border-gray-100 rounded-full px-1.5 py-0.5 -ml-2 z-10 relative" data-id="element-16">
            <div className="bg-[#1877F2] rounded-full p-1" data-id="element-17">
              <ThumbsUp size={10} color="white" fill="white" data-id="element-18" />
            </div>
            <span className="text-[#65676B] font-normal" data-id="element-19">{comment.likes}</span>
          </div>}
      </div>

      {/* Respuestas anidadas */}
      {comment.replies && comment.replies.length > 0 && <div className="pl-2 border-l-2 border-gray-200 mt-2" data-id="element-20">
          {comment.replies.map((reply: any) => <Comment key={reply.id} comment={reply} isReply={true} data-id="element-21" />)}
        </div>}
    </div>
  </div>;
export function App() {
  // Meta Pixel
  useEffect(() => {
    ;
    (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '992624086483436');
    (window as any).fbq('track', 'PageView');
    (window as any).fbq('trackCustom', 'ViewListicle', {
      content_name: 'Listicle Sonvital Drenaje',
      content_category: 'Article'
    });
  }, []);
  // Propaga parámetros de URL a los CTAs y dispara evento Lead al click
  useEffect(() => {
    const urlParams = window.location.search;
    const ctas = document.querySelectorAll<HTMLAnchorElement>('a.cta-pdp');
    const handlers: Array<{
      el: HTMLAnchorElement;
      fn: () => void;
    }> = [];
    ctas.forEach(link => {
      const href = link.getAttribute('href') || '';
      if (urlParams && urlParams.length > 1) {
        const separator = href.includes('?') ? '&' : '?';
        link.setAttribute('href', href + separator + urlParams.substring(1));
      }
      const fn = () => {
        if (typeof (window as any).fbq === 'function') {
          ;
          (window as any).fbq('track', 'Lead', {
            content_name: 'Click CTA Listicle to PDP',
            content_category: 'Listicle'
          });
        }
      };
      link.addEventListener('click', fn);
      handlers.push({
        el: link,
        fn
      });
    });
    return () => {
      handlers.forEach(({
        el,
        fn
      }) => el.removeEventListener('click', fn));
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-22">
      {/* Top Navigation Bar */}
      <nav className="border-b border-gray-200 bg-white sticky top-0 z-50 shadow-sm" data-id="element-23">
        <div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-24">
          <div className="font-serif text-2xl font-bold tracking-tight text-gray-900 flex items-center gap-2" data-id="element-25">
            <Leaf className="text-[#d4738c]" size={24} data-id="element-26" />
            Salud y Bienestar
          </div>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-4 py-10 md:py-16" data-id="element-27">
        {/* Article Header */}
        <header className="mb-10" data-id="element-28">
          <div className="flex items-center gap-2 mb-6" data-id="element-29">
            <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase" data-id="element-30">
              Salud
            </span>
            <span className="text-gray-400 text-xs font-bold tracking-wider uppercase" data-id="element-31">
              |
            </span>
            <span className="text-[#d4738c] text-xs font-bold tracking-wider uppercase" data-id="element-32">
              SALUD MUJER
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl text-gray-900 leading-tight mb-6 font-[600]" data-id="element-33">
            Hoy Te Contamos Por Qué Tu Barriga No Baja (Y No Es Porque No Te
            Esfuerces Lo Suficiente)
            <span className="block mt-4 md:text-3xl italic tracking-tight text-[27px] text-[#000000] font-[300]" data-id="element-34">
              Médicos señalan una causa que la mayoría de mujeres desconoce:
            </span>
          </h1>

          <div className="flex items-center border-t border-b border-gray-100 py-4 mb-8" data-id="element-35">
            <div className="flex-shrink-0 mr-4" data-id="element-36">
              <img src="https://cdn.magicpatterns.com/uploads/cffMcFejcXhujdr5Tjm4WG/ChatGPT_Image_18_jun_2026,_15_37_34.png" alt="Dra. Leticia Villanueva" className="h-12 w-12 rounded-full object-cover" data-id="element-37" />
            </div>
            <div className="text-sm" data-id="element-38">
              <p className="font-bold text-gray-900 text-base" data-id="element-39">
                Por la Dra. Leticia Villanueva
              </p>
              <p className="text-gray-600 m-0" data-id="element-40">
                Endocrinóloga · Madrid, España
              </p>
              <p className="text-gray-500 m-0 text-xs mt-0.5" data-id="element-41">
                25 de febrero de 2026 • Lectura de 5 minutos
              </p>
            </div>
          </div>
        </header>

        {/* Article Body */}
        <article className="article-body prose prose-lg prose-gray max-w-none prose-p:leading-[1.8]" data-id="element-42">
          <div className="bg-rose-50 p-6 rounded-2xl border border-rose-100 mb-10" data-id="element-43">
            <p className="font-bold text-gray-900 m-0" data-id="element-44">
              Si estás leyendo esto, probablemente ya has hecho más de lo que la
              mayoría. Dietas, gimnasio, contar calorías, dejar el pan, el vino,
              los dulces. Y aun así, la barriga sigue ahí. Igual.
            </p>
            <p className="text-gray-900 mt-4 mb-0" data-id="element-45">
              Soy la Dra. Leticia Villanueva, endocrinóloga, y llevo más de
              quince años tratando a mujeres que llegan a mi consulta
              sintiéndose frustradas, agotadas y, sobre todo, culpables. Y lo
              primero que les digo siempre es lo mismo:{' '}
              <strong data-id="element-46">para. No es tu culpa.</strong> Lo que te pasa tiene una
              explicación médica que nadie te ha dado. Y en este artículo te la
              voy a dar.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-47">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-48">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-49">
                1.
              </span>
              Tu Cuerpo Cambió Las Reglas Sin Avisarte
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-50">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-51">
                <img src="https://cdn.magicpatterns.com/uploads/o4iFJ5P2vjs9pcwUbczDwg/ChatGPT_Image_17_jun_2026,_22_24_14.png" alt="A partir de los 40 el cuerpo cambia cómo gestiona la grasa" decoding="async" className="w-full h-auto object-contain" data-id="element-52" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-53">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-54">
                A partir de los 40, tu cuerpo deja de funcionar como funcionaba
                antes. No es una opinión.{' '}
                <strong data-id="element-55">Es endocrinología básica.</strong>
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-56">
                La caída de estrógenos que empieza en la perimenopausia cambia
                por completo cómo tu cuerpo gestiona la grasa. Donde antes
                quemabas, ahora acumulas. Y lo hace justo donde más te frustra:
                en la zona abdominal.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-57">
                Por eso puedes llevar semanas comiendo perfecto y la barriga no
                se mueve. No es que no te esfuerces. Es que tu metabolismo ya no
                responde a las mismas reglas que cuando tenías 30 años.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-58">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-59">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-60">
                2.
              </span>
              La Culpa Que Sientes No Es Tuya: Es Del Consejo Equivocado
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-61">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-62">
                <img src="https://cdn.magicpatterns.com/uploads/nQbNwHWjg7gsrx8NFRKnV1/ChatGPT_Image_17_jun_2026,_23_10_55.png" alt="Mujer sintiéndose culpable por no ver resultados" loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-63" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-64">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-65">
                Cuando haces todo "bien" y no ves resultados, la conclusión
                lógica es: "no estoy haciendo lo suficiente." Y eso te lleva a
                restringir más, a machacarte más, a sentirte peor contigo misma.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-66">
                En mi consulta he visto a mujeres que apenas comían. Mujeres que
                iban al gimnasio cinco días a la semana. Y todas llegaban
                diciendo lo mismo: "Doctora, siento que no lo intento lo
                suficiente."
              </p>
              <p style={{
              marginBottom: '24px'
            }} className="italic text-gray-600 border-l-4 border-gray-300 pl-4" data-id="element-67">
                Sí lo intentan. Lo que pasa es que las soluciones que les han
                dado no están diseñadas para lo que tienen. No es un fallo de
                disciplina. Es un fallo de diagnóstico.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-68">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-69">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-70">
                3.
              </span>
              Las Dietas Restrictivas Están Empeorando Tu Problema
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-71">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-72">
                <img src="https://cdn.magicpatterns.com/uploads/nVsaJiFqJ8aekvNHUW5qn4/ChatGPT_Image_17_jun_2026,_23_12_02.png" alt="Dietas restrictivas que ralentizan el metabolismo" loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-73" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-74">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-75">
                Las dietas bajas en calorías funcionan en metabolismos jóvenes y
                hormonalmente estables. En un cuerpo de 40+ con desequilibrio
                hormonal, hacen exactamente lo contrario de lo que quieres.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-76">
                Cuando restringes calorías de forma agresiva, tu metabolismo se
                frena aún más como respuesta de supervivencia. Pierdes músculo,
                no grasa abdominal. Y cuando dejas la dieta, recuperas más de lo
                que perdiste: el famoso efecto rebote.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-77">
                No es que la dieta "no te funcionó." Es que la dieta le hizo
                daño a un metabolismo que ya estaba lento.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-78">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-79">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-80">
                4.
              </span>
              El Ejercicio Solo No Soluciona La Grasa Hormonal
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-81">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-82">
                <img src="https://cdn.magicpatterns.com/uploads/fi2FDDrUUPN7bVuGw1TE1o/ChatGPT_Image_17_jun_2026,_23_20_38.png" alt="La grasa hormonal no responde solo al ejercicio" loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-83" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-84">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-85">
                Hacer ejercicio es bueno. Pero si tu sistema hormonal y tu
                sistema linfático están atascados, la grasa abdominal no se
                mueve por mucho que te machaques.
              </p>
              <p style={{
              marginBottom: '24px'
            }} className="font-bold text-xl text-gray-900" data-id="element-86">
                La grasa hormonal responde a señales hormonales, no solo a
                déficit calórico.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-87">
                Y si esas señales están alteradas, puedes hacer abdominales
                todos los días del año y la barriga va a seguir exactamente
                donde está.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-6 md:gap-8 items-start mt-12" data-id="element-88">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-0 flex items-start gap-3 mt-0 md:col-start-2 md:row-start-1" data-id="element-89">
              <span className="text-[#d4738c] font-black text-3xl md:text-4xl leading-none" data-id="element-90">
                5.
              </span>
              Los Suplementos "Quemagrasa" No Van A La Raíz
            </h2>
            <figure className="w-full flex-shrink-0 m-0 md:row-span-2 md:row-start-1" data-id="element-91">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-92">
                <img src="https://cdn.magicpatterns.com/uploads/92rkY6XqEsaSKJstXqYHY9/ChatGPT_Image_17_jun_2026,_23_32_31.png" alt="Suplementos quemagrasa que solo tratan el síntoma" loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-93" />
              </div>
            </figure>
            <div className="md:col-start-2" data-id="element-94">
              <p style={{
              marginBottom: '24px'
            }} data-id="element-95">
                La mayoría de suplementos para perder peso son estimulantes:
                cafeína, termogénicos, extractos que aceleran el corazón.
              </p>
              <p style={{
              marginBottom: '24px'
            }} data-id="element-96">
                Te dan energía un rato. Quizá te quitan el hambre unas horas.
                Pero no tocan el problema hormonal. No tocan el sistema
                linfático. No tocan la causa por la que tu cuerpo acumula grasa
                en la barriga.
              </p>
              <p style={{
              marginBottom: '24px'
            }} className="font-bold text-[#d4738c]" data-id="element-97">
                Tratan el síntoma, no la causa. Y cuando dejas de tomarlos,
                estás exactamente igual. O peor.
              </p>
            </div>
          </div>

          {/* Solution Section */}
          <div className="mt-16 mb-12" data-id="element-98">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center" data-id="element-99">
              Lo Que De Verdad Necesita Tu Cuerpo A Partir De Los 40
            </h2>
            <p className="text-center text-xl mb-8" data-id="element-100">
              Para que la grasa abdominal empiece a moverse, hay que actuar en
              tres niveles:
            </p>

            <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200" data-id="element-101">
              <ul className="space-y-4 m-0 p-0 list-none" data-id="element-102">
                <li className="flex items-start gap-3" data-id="element-103">
                  <Check className="text-green-500 mt-1 shrink-0" size={24} data-id="element-104" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-105">
                    Reactivar el sistema linfático dormido para que el cuerpo
                    vuelva a drenar correctamente
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-106">
                  <Check className="text-green-500 mt-1 shrink-0" size={24} data-id="element-107" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-108">
                    Mover el líquido y la grasa acumulada estancados en los
                    tejidos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-109">
                  <Check className="text-green-500 mt-1 shrink-0" size={24} data-id="element-110" />
                  <span className="text-lg font-medium text-gray-800" data-id="element-111">
                    Apoyar el equilibrio hormonal desde dentro, no con parches
                    externos
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-16 mb-6" data-id="element-112">
            Lo Que Descubrí Cuando Una Paciente Me Dejó Sin Respuesta
          </h2>

          <p data-id="element-113">
            Durante años fui escéptica con los suplementos para perder peso. En
            mi consulta había visto pasar de todo: pastillas milagro, batidos
            sustitutivos, fórmulas "revolucionarias" que no revolucionaban nada.
            Por eso, cuando mis pacientes me preguntaban por alternativas,
            siempre les daba la misma respuesta: ajuste hormonal, alimentación
            adaptada, ejercicio moderado, y paciencia.
          </p>

          <p data-id="element-114">Hasta que llegó Laura.</p>

          <p data-id="element-115">
            Laura es paciente mía desde hace cuatro años. 47 años, en
            perimenopausia, con una acumulación de grasa abdominal que no
            respondía a nada. Comía bien. Iba al gimnasio tres veces por semana.
            Hacía todo lo que yo le decía. Y la barriga no bajaba. Un día entró
            en la consulta y algo era diferente: la ropa le quedaba de otra
            manera, la cara más definida. Le pregunté qué había cambiado y me
            dijo, casi avergonzada, que llevaba tres semanas tomando una fórmula
            botánica que había encontrado por su cuenta.
          </p>

          <p data-id="element-116">
            Me molestó. No por ella — por mí. Llevaba años dándole protocolos
            caros y lentos, y resulta que una mezcla de plantas que yo nunca le
            había mencionado le había hecho más en 21 días que todo lo anterior
            junto.
          </p>

          <p data-id="element-117">
            Así que hice lo que tenía que hacer: me senté a estudiar la fórmula
            ingrediente por ingrediente. Iba con la idea de desmontarla.
            Esperaba encontrarme con lo de siempre — extractos a dosis
            ridículas, plantas de relleno, marketing vestido como ciencia.
          </p>

          <p data-id="element-118">No fue eso lo que encontré.</p>

          <h3 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-119">
            La planta que la fitoterapia moderna olvidó
          </h3>

          <p data-id="element-120">
            El componente que me hizo cambiar de opinión no era ninguno de los
            típicos quemagrasa que se ven en cualquier herbolario. Era una raíz
            que los médicos eclécticos americanos del siglo XIX usaban para
            tratar congestiones linfáticas crónicas:{' '}
            <strong data-id="element-121">la Raíz de Stillingia</strong>.
          </p>

          <p data-id="element-122">
            Lo que descubrí leyendo la literatura es que Stillingia no actúa
            sobre la grasa directamente — actúa sobre los vasos linfáticos en
            sí. Concretamente, sobre los bloqueos profundos en los ganglios. Los
            que las dietas y el ejercicio nunca alcanzan.
          </p>

          <p data-id="element-123">
            Mientras el resto de soluciones del mercado intentan quemar grasa
            desde fuera (menos calorías, más ejercicio, estimulantes),
            Stillingia se ocupa de abrir el conducto por el que el líquido y la
            grasa acumulada tienen que salir. Sin esto, todo lo demás es trabajo
            perdido.
          </p>

          <p data-id="element-124">
            Por algún motivo, la fitoterapia moderna la dejó atrás. Hoy es
            prácticamente imposible encontrarla en suplementos europeos. Por eso
            ninguna de mis pacientes — ni yo misma — la conocíamos.
          </p>

          <h3 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-125">
            Pero Stillingia sola no es suficiente
          </h3>

          <p data-id="element-126">
            Aquí está lo que me terminó de convencer de la fórmula. La
            Stillingia abre los bloqueos, pero si los vasos linfáticos están
            dormidos, no sirve de nada destapar la salida. Y aunque consigas
            mover el líquido, si la microcirculación final está cerrada, todo se
            queda atrapado a un milímetro de salir.
          </p>

          <p data-id="element-127">
            Por eso la fórmula incluye otras tres plantas que cumplen funciones
            muy concretas:
          </p>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-200 my-8" data-id="element-128">
            <ul className="space-y-4 m-0 p-0 list-none" data-id="element-129">
              <li className="flex items-start gap-3" data-id="element-130">
                <Leaf className="text-[#d4738c] mt-1 shrink-0" size={24} data-id="element-131" />
                <div data-id="element-132">
                  <strong className="text-gray-900" data-id="element-133">Amor de Hortelano</strong> —
                  la planta que despierta los vasos linfáticos dormidos y los
                  pone a trabajar otra vez.
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-134">
                <Leaf className="text-[#d4738c] mt-1 shrink-0" size={24} data-id="element-135" />
                <div data-id="element-136">
                  <strong className="text-gray-900" data-id="element-137">
                    Corteza de Fresno Espinoso
                  </strong>{' '}
                  — reabre la microcirculación periférica, el último tramo del
                  recorrido por donde el líquido y la grasa acumulada salen.
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-138">
                <Leaf className="text-[#d4738c] mt-1 shrink-0" size={24} data-id="element-139" />
                <div data-id="element-140">
                  <strong className="text-gray-900" data-id="element-141">Trébol Rojo</strong> —
                  específicamente para mujeres a partir de los 40: regula el
                  desajuste hormonal que acelera la acumulación de grasa
                  abdominal.
                </div>
              </li>
            </ul>
          </div>

          <p data-id="element-142">
            Y hay un detalle más, técnico pero importante: la fórmula está en
            extracto líquido, no en cápsula. Esto es bioquímica: Un extracto
            líquido se absorbe en mucosa oral y entra en circulación en minutos,
            mientras que una cápsula tiene que pasar por digestión completa y
            pierde gran parte del principio activo por el camino. Para plantas
            como Stillingia, que actúan a dosis bajas, esto marca la diferencia
            entre notar resultados o no notar nada.
          </p>

          <p data-id="element-143">
            Las cuatro plantas trabajan en secuencia, no en paralelo. Y la
            proporción exacta entre ellas es lo que hace que funcione. Si tomas
            Stillingia por separado, no notas nada. Si la combinas con las otras
            tres en las cantidades correctas y en el formato adecuado, entonces
            el sistema entero se activa.
          </p>

          <p data-id="element-144">
            Esa fórmula tiene un nombre comercial en España:{' '}
            <strong data-id="element-145">Sonvital™</strong>.
          </p>

          <p data-id="element-146">
            Es lo que estaba tomando Laura. Y desde hace ya un año, es lo que
            recomiendo en mi consulta a cada paciente que entra por la puerta
            sintiéndose culpable por no perder peso.
          </p>

          <figure className="mt-8 mb-2 max-w-xs sm:max-w-sm mx-auto" data-id="element-147">
            <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-148">
              <img src="https://cdn.magicpatterns.com/uploads/b7xPPr6ZBc954T22xB7aLx/ChatGPT_Image_18_jun_2026,_07_57_05.png" alt="Dra. Leticia Villanueva en su consulta" loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-149" />
            </div>
          </figure>

          <h2 className="text-3xl font-bold text-gray-900 mt-4 mb-6" data-id="element-150">
            Mi Conclusión:
          </h2>

          <p data-id="element-151">
            A mis pacientes siempre les digo lo mismo: la barriga que no baja
            con dieta no se soluciona con más dieta.
          </p>

          <p data-id="element-152">
            Si puedes permitirte un endocrino, un nutricionista y un entrenador
            personal adaptado a tu perfil hormonal, adelante. Pero la mayoría no
            pueden gastarse 200€ al mes en eso.
          </p>

          <p data-id="element-153">
            Por eso, Sonvital es hoy la mejor relación calidad-precio del
            mercado español. Fórmula seria, fabricación europea y garantía de 60
            días para probarlo sin riesgo.
          </p>

          <p data-id="element-154">
            No es un milagro. Ningún suplemento lo es. Pero los resultados que
            están reportando las mujeres son, sencillamente, impresionantes.
          </p>

          {/* Inline CTA */}
          <div className="my-10 text-center" data-id="element-155">
            <a href="https://sonvital.com/products/nueva-formula" className="cta-pdp inline-flex items-center justify-center gap-2 bg-[#d4738c] hover:bg-[#b0556d] text-white text-lg md:text-xl font-bold py-4 px-8 md:px-10 rounded-full shadow-lg transform transition hover:scale-105 w-full md:w-auto no-underline" data-id="element-156">
              👉 Comprobar Disponibilidad — 50% DESCUENTO
            </a>
            <p className="text-sm text-gray-500 mt-3 flex items-center justify-center gap-2" data-id="element-157"></p>
          </div>

          {/* Product Section */}
          <div className="bg-white border-2 border-[#d4738c] rounded-3xl p-8 md:p-10 shadow-xl my-12 relative overflow-hidden" data-id="element-158">
            <div className="md:absolute md:top-0 md:right-0 inline-block bg-[#d4738c] text-white px-4 md:px-6 py-2 rounded-full md:rounded-bl-2xl md:rounded-full-none md:rounded-tr-none font-bold text-xs md:text-sm tracking-wider mb-4 md:mb-0" data-id="element-159">
              FÓRMULA 4 EN 1
            </div>

            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:pr-32" data-id="element-160">
              Esta Fórmula Actúa Sobre La Causa Real
            </h3>

            <figure className="my-8" data-id="element-161">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-162">
                <img src="https://cdn.magicpatterns.com/uploads/qh9YHzd157mgzcrffnAyuE/724046441_122106843692344312_2065465741665549412_n.jpg" alt="Antes y después: menos hinchazón, más ligereza" loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-163" />
              </div>
            </figure>

            <figure className="my-8" data-id="element-164">
              <img src="https://cdn.magicpatterns.com/uploads/9bqYiuvYnc4dRTtfc7ACym/Captura_de_pantalla_2026-05-09_a_las_19.30.34.png" alt="Sonvital" loading="lazy" decoding="async" className="w-full max-w-md mx-auto h-auto object-contain" data-id="element-165" />
            </figure>

            <p className="text-lg mb-8" data-id="element-166">
              <strong data-id="element-167">Sonvital</strong> es una fórmula botánica que:
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-168">
              <div className="bg-rose-50 p-5 rounded-xl" data-id="element-169">
                <Activity className="text-[#d4738c] mb-3" size={32} data-id="element-170" />
                <p className="text-sm font-bold text-gray-900 m-0" data-id="element-171">
                  Activa los vasos linfáticos dormidos para que el líquido y la
                  grasa acumulada vuelvan a moverse
                </p>
              </div>
              <div className="bg-rose-50 p-5 rounded-xl" data-id="element-172">
                <Droplets className="text-[#d4738c] mb-3" size={32} data-id="element-173" />
                <p className="text-sm font-bold text-gray-900 m-0" data-id="element-174">
                  Disuelve la congestión de los ganglios para que el drenaje
                  fluya
                </p>
              </div>
              <div className="bg-rose-50 p-5 rounded-xl" data-id="element-175">
                <Activity className="text-[#d4738c] mb-3" size={32} data-id="element-176" />
                <p className="text-sm font-bold text-gray-900 m-0" data-id="element-177">
                  Abre la microcirculación para que lo que sobra salga del
                  cuerpo
                </p>
              </div>
            </div>

            <h4 className="font-bold text-xl mb-4" data-id="element-178">
              Contiene 4 plantas con respaldo científico:
            </h4>
            <ul className="space-y-3 mb-8 text-gray-700" data-id="element-179">
              <li data-id="element-180">
                🌿 <strong data-id="element-181">Amor de Hortelano:</strong> la llamada "escoba
                linfática"
              </li>
              <li data-id="element-182">
                🌿 <strong data-id="element-183">Trébol Rojo:</strong> regula el exceso hormonal a
                partir de los 40
              </li>
              <li data-id="element-184">
                🌿 <strong data-id="element-185">Raíz de Stillingia:</strong> ataca los bloqueos más
                rebeldes
              </li>
              <li data-id="element-186">
                🌿 <strong data-id="element-187">Corteza de Fresno Espinoso:</strong> reactiva la
                microcirculación
              </li>
            </ul>

            <div className="border-t border-gray-200 pt-8" data-id="element-188">
              <h4 className="font-bold text-xl mb-2 text-[#d4738c]" data-id="element-189">
                Se toma así:
              </h4>
              <p className="text-lg text-gray-800" data-id="element-190">
                ¼ de cucharadita al día disuelta en agua, café o zumo por la
                mañana. Ya está. Cada bote incluye su cucharilla dosificadora.
              </p>
            </div>
          </div>

          {/* Social Proof & Offer */}
          <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-start mt-16" data-id="element-191">
            <figure className="md:w-2/5 w-full flex-shrink-0 m-0" data-id="element-192">
              <div className="w-full bg-gray-50 rounded-2xl overflow-hidden shadow-md" data-id="element-193">
                <img src="https://cdn.magicpatterns.com/uploads/jNbgocFgrd5eAtELWQ7MJY/ChatGPT_Image_17_jun_2026,_23_52_33.png" alt="Mujeres usando Sonvital en su rutina diaria" loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-194" />
              </div>
            </figure>
            <div className="flex-1" data-id="element-195">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-0" data-id="element-196">
                Siente El Cambio Del Que Hablan Miles De Mujeres, Sin Riesgo
              </h2>
              <p className="text-lg mb-6" data-id="element-197">
                Miles de mujeres españolas ya lo han incorporado a su rutina
                diaria para dejar de pelear con la báscula, verse mejor en el
                espejo, y dejar de esconder la barriga debajo de ropa ancha.
              </p>
            </div>
          </div>

          <p className="text-center text-gray-600 mt-8 mb-12" data-id="element-198">
            Muchas notan cambios en las primeras dos semanas. Otras en tres. Y
            lo mejor: cada pedido viene con una garantía de devolución de 60
            días. Si no notas la diferencia, devuelves el frasco (aunque esté
            vacío) y te devuelven el dinero. Sin preguntas.
          </p>

          <div className="bg-gray-900 text-white rounded-3xl p-8 md:p-12 text-center shadow-2xl mb-16" data-id="element-199">
            <div className="inline-block bg-red-500 text-white px-4 py-1 rounded-full text-sm font-bold animate-pulse mb-6" data-id="element-200">
              ⚠️ STOCK LIMITADO — Últimos packs disponibles
            </div>

            <div className="mb-8 mx-auto w-64 md:w-72 h-56 md:h-64 rounded-2xl overflow-hidden shadow-lg" data-id="element-201">
              <img src="https://cdn.magicpatterns.com/uploads/jGSKyduy2BiH9vhjqUaGrt/Captura_de_pantalla_2026-04-23_a_las_8.53.21.png" alt="Bote de Sonvital" loading="lazy" decoding="async" className="w-full h-full object-contain" data-id="element-202" />
            </div>

            <div className="space-y-4 mb-8 text-lg" data-id="element-203">
              <div className="flex items-center justify-center gap-3" data-id="element-204">
                <Truck className="text-[#d4738c]" data-id="element-205" />
                <span data-id="element-206">
                  Envío <strong data-id="element-207">GRATIS en 24-48h</strong> en toda España
                </span>
              </div>

              <div className="flex items-center justify-center gap-3" data-id="element-208">
                <CheckCircle className="text-[#d4738c]" data-id="element-209" />
                <span className="text-xl text-yellow-400 font-bold bg-[#00000000]" data-id="element-210">
                  🎁 50% DE DESCUENTO (Oferta Limitada)
                </span>
              </div>
            </div>

            <a href="https://sonvital.com/products/nueva-formula" className="cta-pdp inline-flex items-center justify-center gap-2 bg-[#d4738c] hover:bg-[#b0556d] text-white text-xl md:text-2xl font-bold py-5 px-8 md:px-12 rounded-full shadow-lg transform transition hover:scale-105 w-full md:w-auto no-underline" data-id="element-211">
              Comprobar Disponibilidad <ChevronRight size={28} data-id="element-212" />
            </a>
          </div>
        </article>

        {/* Facebook Comments Section */}
        <section className="mt-16 border-t border-gray-200 pt-8" data-id="element-213">
          <div className="flex items-center gap-2 mb-6 border-b border-gray-200 pb-2" data-id="element-214">
            <MessageCircle className="text-gray-500" data-id="element-215" />
            <h3 className="text-lg font-bold text-gray-900 m-0" data-id="element-216">Comentarios</h3>
          </div>

          <div className="space-y-2" data-id="element-217">
            {commentsData.map(comment => <Comment key={comment.id} comment={comment} data-id="element-218" />)}
          </div>

          <div className="mt-12 text-center" data-id="element-219">
            <a href="https://sonvital.com/products/nueva-formula" className="cta-pdp inline-block bg-[#d4738c] hover:bg-[#b0556d] text-white text-lg font-bold py-4 px-10 rounded-full shadow-md transition-colors no-underline w-full md:w-auto" data-id="element-220">
              👉 Comprobar Disponibilidad — DESCUENTO DEL 50%
            </a>
          </div>
        </section>

        {/* Footer */}
        <footer className="mt-20 pt-10 border-t border-gray-200 text-center text-gray-500 text-sm" data-id="element-221">
          <p className="mb-4" data-id="element-222">
            © 2026 Salud y Bienestar. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 mb-8" data-id="element-223">
            <a href="#" className="hover:text-gray-900" data-id="element-224">
              Privacidad
            </a>
            <a href="#" className="hover:text-gray-900" data-id="element-225">
              Términos
            </a>
            <a href="#" className="hover:text-gray-900" data-id="element-226">
              Contacto
            </a>
          </div>
          <p className="text-xs text-gray-400 max-w-2xl mx-auto" data-id="element-227">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </footer>
      </main>
    </div>;
}